import {
  DaypartTitle,
  StyledResourceWrapper,
} from 'src/features/locations/calendarLocationGroupPage/modules/CalendarView/CalendarView.styled';

import { ResourceContentProps } from './ResourceContent.interface';

export const ResourceContent = ({ resource }: ResourceContentProps) => {
  return (
    <StyledResourceWrapper>
      <DaypartTitle>{resource?.title}</DaypartTitle>
    </StyledResourceWrapper>
  );
};
